export {
  BUILD_AI_AGENTS_WEBINAR_ATF_SLOT_END_ISO_LOCAL,
  BUILD_AI_AGENTS_WEBINAR_REGISTRATION_HREF,
  isBuildAiAgentsWebinarAtfSlotActive,
} from '~/utils/build-ai-agents-webinar-atf-slot';
